module.exports = __webpack_public_path__ + "static/media/wheel.f7b561ba.svg";